/* ACTIVeat wordmark.

   The brand is not written "Activeat" - the mark sets ACTIV in the heavy weight
   and eat in a light one, and that lockup is the only form of the name the
   business uses on packaging, on the vans and on the logo badge in the header.
   Everywhere the name appeared as running text the site was quietly writing it
   a third way.

   Two halves to the fix. The copy itself has been corrected to "ACTIVeat" in
   the templates and section defaults, so the name is right with or without this
   file - that is the part that matters, and it is why this runs as a progressive
   enhancement rather than as the source of truth. This file then dresses those
   occurrences in the two-weight lockup.

   It is done in the DOM rather than in Liquid because almost every occurrence
   arrives through a theme setting - a kicker, a heading, an alt string, a
   schema default - and none of those can carry markup. A Liquid filter would
   have to be threaded through forty output statements and would still miss the
   ones inside `inline_richtext`.

   Deliberately narrow: it only walks the page wrapper, never form controls
   (typing into a field whose value had been rewritten would be a real bug),
   never code or preformatted text, and never a node it has already touched. */
(() => {
  /* Both spellings. The templates and section defaults were corrected to
     ACTIVeat, but plenty of the name arrives from store data the theme cannot
     edit - the shop name in the header, product titles like "Activeat Signature
     Flour", and every dish on the weekly menu, which is a metaobject typed in
     the admin. Matching the old spelling too means those render as the wordmark
     as well, and correcting them at source later changes nothing here. */
  const RE = /ACTIVeat|Activeat/g;

  /* Anything whose text is really a value, a command or a literal. Rewriting
     inside these ranges from cosmetic to actively wrong. */
  const SKIP = new Set([
    'SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE', 'TITLE',
    'INPUT', 'TEXTAREA', 'SELECT', 'OPTION', 'BUTTON',
    'CODE', 'PRE', 'KBD', 'SAMP',
  ]);

  const skippable = (el) => {
    for (let n = el; n && n !== document.body; n = n.parentElement) {
      if (SKIP.has(n.nodeName)) return true;
      if (n.isContentEditable) return true;
      /* Already dressed, or explicitly opted out by a section that needs the
         plain string (a meta value, a copy-to-clipboard target). */
      if (n.classList && (n.classList.contains('aat-wm') || n.hasAttribute('data-aat-no-wordmark'))) return true;
    }
    return false;
  };

  const dress = (root) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !/ACTIVeat|Activeat/.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        return skippable(node.parentElement) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      },
    });

    /* Collected first, replaced after. Splitting a text node while the walker
       is still pointing into it invalidates its position. */
    const hits = [];
    while (walker.nextNode()) hits.push(walker.currentNode);

    hits.forEach((node) => {
      const frag = document.createDocumentFragment();
      let last = 0;
      const text = node.nodeValue;
      RE.lastIndex = 0;
      let m;
      while ((m = RE.exec(text)) !== null) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        const wm = document.createElement('span');
        wm.className = 'aat-wm';
        wm.appendChild(document.createTextNode('ACTIV'));
        const tail = document.createElement('i');
        tail.appendChild(document.createTextNode('eat'));
        wm.appendChild(tail);
        frag.appendChild(wm);
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  };

  const run = () => dress(document.querySelector('.page-wrapper'));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  /* The theme editor re-renders a single section in place, which drops back to
     the raw string. Re-dress just that section rather than the whole page. */
  document.addEventListener('shopify:section:load', (e) => dress(e.target));
})();
